/**
 * Attestation disclaimer text and document-hash payload helpers shared by UI and Entity Manager.
 */

export const ENOVA_APPLICATION_TITLE = 'Enterprise Onboarding and Verification Application (eNOVA)';

const ATTESTATION_CONSENT_PARAGRAPH =
  'By selecting Sign and Submit, I agree that the signature will be the electronic representation of my signature for all purposes when I use them on documents, including legally binding contracts - just the same as pen-and-paper signature.';

export function getAttestationDisclaimerText(applicationTitle: string): string {
  const submissionParagraph = `By clicking Sign and Submit you are submitting your ${applicationTitle} with this digital signature.`;

  return `${ATTESTATION_CONSENT_PARAGRAPH}\n${submissionParagraph}`;
}

export function stableStringify(value: unknown): string {
  if (value === null || typeof value !== 'object') {
    return JSON.stringify(value);
  }

  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(',')}]`;
  }

  const record = value as Record<string, unknown>;
  const keys = Object.keys(record).sort();

  return `{${keys.map((key) => `${JSON.stringify(key)}:${stableStringify(record[key])}`).join(',')}}`;
}

export function applicationDataForDocumentHash(applicationData: Record<string, unknown>): Record<string, unknown> {
  const { attestation: _attestation, ...dataWithoutAttestation } = applicationData;

  return dataWithoutAttestation;
}

export function getDocumentHashPayload(applicationData: Record<string, unknown>): string {
  return stableStringify(applicationDataForDocumentHash(applicationData));
}
